import React from "react";

const Export = props => {
  return <h1>Export Component</h1>;
};

export default Export;
